import React from 'react';
import { Link } from 'react-router-dom';

const MAX_ITEMS = 5;

export default function TrendingJournalists({ articles }) {
  const seen = new Set();
  const journalists = [];

  for (const article of articles || []) {
    const j = article.journalist;
    if (j && !seen.has(j.id)) {
      seen.add(j.id);
      journalists.push(j);
    }
    if (journalists.length >= MAX_ITEMS) break;
  }

  return (
    <section className="sidebar-section">
      <h2 className="section-heading">Trending Journalists</h2>

      {journalists.length === 0 ? (
        <p className="state-message">Nothing trending yet.</p>
      ) : (
        <ol className="trending-list">
          {journalists.map((j, i) => (
            <li key={j.id} className="trending-list__item">
              <span className="trending-list__rank">{i + 1}</span>
              <Link to={`/journalists/${j.documentId}`} className="trending-list__title">
                {j.firstName} {j.lastName}
              </Link>
            </li>
          ))}
        </ol>
      )}
    </section>
  );
}
